import "../assets/Text.css";
import { ref as X, computed as p, defineComponent as K, openBlock as f, createElementBlock as b, normalizeClass as Z, unref as g, normalizeStyle as U, withModifiers as ee, createElementVNode as L, createCommentVNode as te, createVNode as ne, Fragment as oe, renderList as ae, createBlock as j, resolveDynamicComponent as re } from "vue";
import { d as ie } from "./debounce.BDLEW31m.js";
import { p as se } from "./widgets-core.es.DdX21Kyh.js";
import { h as u, A as y, e as a, i as G, g as T, L as v, D as C, j as ue, T as $ } from "./maps.ChaVcqWI.js";
import { q as le, e as z, i as de, o as q, s as pe, B as x } from "./useStore.BHVfM1RP.js";
function ce(n) {
  return n && n.length ? n[0] : void 0;
}
const me = {
  [u.ApplyPromoCode]: y.ApplyDiscount,
  [u.CloseTool]: y.NoAction,
  [u.EmailCapture]: y.SendSubscribe,
  emailCapture: y.SendSubscribe,
  [u.SendForm]: y.SendForm,
  [u.OpenUrl]: y.OpenUri,
  [u.CallPhoneNumber]: y.OpenUri,
  [u.OpenMailClient]: y.OpenUri,
  [u.SavedSearch]: y.SendSaveSearch,
  savedSearch: y.SendSaveSearch,
  [u.OpenBookingEngine]: y.OpenBookingEngine,
  [u.LastSearch]: y.OpenBookingEngine
};
function D(n) {
  return me[n];
}
const O = le();
let F = 0;
function ye() {
  return F += 1, `extra-modules-${F}`;
}
function w(n) {
  const e = O.getLiteral(n), t = {
    [O.language]: e
  };
  return {
    sync: !0,
    id: ye(),
    mobile: t,
    desktop: t
  };
}
function A(n = "") {
  return {
    ...w(n),
    moduleType: a.Heading
  };
}
function H(n = "") {
  return {
    ...w(n),
    moduleType: a.Paragraph
  };
}
function B(n, e) {
  return {
    ...w(e),
    moduleType: a.Button,
    behaviour: {
      type: n
    }
  };
}
const ge = {
  [a.EmailCapture]: "Your email address has been successfully added to our list.",
  [a.SavedSearch]: "We will send you an email with your search very soon.",
  [a.Form]: "We have received your form submission correctly"
}, N = {
  [u.ApplyPromoCode]: "Apply promocode",
  [u.OpenUrl]: "Continue",
  [u.CloseTool]: "Close",
  [u.OpenBookingEngine]: "Book Now",
  [u.OpenMailClient]: "Contact Now",
  [u.CallPhoneNumber]: "Call Now"
}, W = X(), he = [
  a.SavedSearch,
  a.EmailCapture,
  a.Form,
  a.Login
];
function fe(n) {
  var e;
  return ((e = n.find(
    (t) => he.includes(t.moduleType)
  )) == null ? void 0 : e.moduleType) || "";
}
function E(n) {
  var e;
  return (e = n.find(
    (t) => t.moduleType === a.Button
  )) == null ? void 0 : e.behaviour.type;
}
function Se(n, e) {
  return n.filter((t) => {
    if (t.moduleType !== a.Button) return !1;
    const o = t;
    return o.kind === G.Secondary && o.primaryButtonId === e;
  });
}
function Te(n) {
  return n.reduce((e, t) => {
    var i;
    if (t.moduleType !== a.Button) return [...e, t];
    if (t.kind === G.Secondary) return e;
    const l = Se(n, t.id);
    return [...e, {
      ...t,
      alignment: (i = ce(l)) == null ? void 0 : i.alignment,
      secondaryButtons: l
    }];
  }, []);
}
function Ke(n) {
  const e = Te(n), t = {
    [T.Main]: e
  }, o = fe(e), l = e.find(
    (h) => h.moduleType === a.Login
  );
  if (!o) return t;
  if (l) {
    const h = e.find(
      (m) => m.moduleType === a.Button
    );
    if (t[T.Main] = e.reduce((m, d) => d.moduleType === a.Button ? m : d.moduleType === a.Login ? [
      ...m,
      {
        ...d,
        buttonModule: h,
        currentView: v.LoginRegister
      }
    ] : [...m, d], []), t[v.LoginSignin] = e.reduce((m, d) => d.moduleType !== a.Login ? m : d.moduleType === a.Login ? [
      ...m,
      {
        ...d,
        buttonModule: h,
        currentView: v.LoginSignin
      }
    ] : [...m, d], []), !o)
      return t;
    const _ = E(e), R = N[_] || "Close";
    t[v.LoginSuccess] = e.reduce((m, d) => d.moduleType !== a.Login && d.moduleType !== a.Button ? m : d.moduleType === a.Button ? [
      ...m,
      {
        ...B(_, R)
      }
    ] : d.moduleType === a.Login ? [
      ...m,
      {
        ...d,
        currentView: v.LoginSuccess
      }
    ] : [...m, d], []);
    const Y = p(() => A("There has been an error.")), J = p(() => H("Something went wrong. Please, try again later.")), Q = p(() => B(u.GoMainStep, "Back"));
    return t[T.Failure] = [
      Y.value,
      J.value,
      Q.value
    ], t;
  }
  const c = E(e), i = N[c] || "Close", r = p(() => A("Thank you!")), s = p(() => H(
    ge[o]
  )), S = p(
    () => B(c, i)
  ), P = p(() => A("There has been an error.")), k = p(() => H("Something went wrong. Please, try again later.")), M = p(() => B(u.GoMainStep, "Back"));
  return t[T.Success] = [
    r.value,
    s.value,
    S.value
  ], t[T.Failure] = [
    P.value,
    k.value,
    M.value
  ], E(e) === "submit" && (t[T.Success].pop(), t[T.Failure].pop()), t;
}
const be = {
  fontSize: 16,
  lineHeight: 16,
  letterSpacing: 0
};
function I(n = be, e = C.Desktop, t) {
  const {
    fontSize: o,
    lineHeight: l,
    letterSpacing: c
  } = n;
  let i;
  e === C.Desktop && t === ue.Compact ? i = 0.865 : e === C.Mobile ? i = 0.8 : i = 1;
  const r = Math.round(o * i), s = Math.round(l), S = (c ?? 0) / 100;
  return {
    fontSize: z(r),
    lineHeight: z(s),
    letterSpacing: c ? de(S) : "normal"
  };
}
const ve = ["button-state", "moduleType", "data-module-id", "data-full-width", "aria-label", "aria-busy"], Pe = ["innerHTML"], ke = ["innerHTML"], Me = ["aria-label"], V = /* @__PURE__ */ K({
  __name: "Button",
  props: {
    moduleProps: {},
    hasExtraSteps: {},
    isLinkLayout: { type: Boolean },
    isSecondary: { type: Boolean },
    toolKind: {},
    layout: {}
  },
  setup(n) {
    const e = q(), { t } = se(), o = n, l = p(() => {
      var r;
      return e == null ? void 0 : e.literals.getActiveModuleText(
        o.moduleProps,
        ((r = e == null ? void 0 : e.styles.fonts[o.moduleProps.moduleType]) == null ? void 0 : r.textTransform) === $.Titlecase,
        {
          candidates: e.extraData.dynamicTags,
          replacement: e.extraData.tokens
        }
      );
    }), c = p(
      () => {
        var r;
        return I(
          o.moduleProps.appearance,
          e == null ? void 0 : e.device,
          (r = o.layout) == null ? void 0 : r.size
        );
      }
    ), i = ie(() => {
      if ((e == null ? void 0 : e.handlers.buttonState) !== x.Sending)
        if (o.hasExtraSteps && !o.moduleProps.id.includes("extra"))
          W.value && (W.value.scrollTop = 0), e == null || e.handlers.callHandler(D(o.hasExtraSteps));
        else if (o.moduleProps.behaviour.type === u.GoMainStep)
          e == null || e.handlers.goBackToMainStep();
        else {
          const r = D(o.moduleProps.behaviour.type);
          e == null || e.handlers.callHandler(r, o.moduleProps.id);
        }
    }, 200, { leading: !0, trailing: !1 });
    return (r, s) => {
      var S, P, k, M;
      return f(), b("button", {
        class: Z([
          "thn--tool-button",
          {
            "inline-layout": r.isLinkLayout,
            "thn--tool-button__secondary": r.isSecondary,
            "bg-color": !r.isLinkLayout,
            "bg-color-secondary": !r.isLinkLayout && r.isSecondary
          }
        ]),
        "button-state": (S = g(e)) == null ? void 0 : S.handlers.buttonState,
        style: U(c.value),
        moduleType: r.moduleProps.moduleType,
        "data-module-id": r.moduleProps.id,
        "data-full-width": (P = r.moduleProps.appearance) == null ? void 0 : P.fullWidth,
        onMousedown: s[0] || (s[0] = ee(
          //@ts-ignore
          (...h) => g(i) && g(i)(...h),
          ["left"]
        )),
        onClick: s[1] || (s[1] = //@ts-ignore
        (...h) => g(i) && g(i)(...h)),
        "aria-label": l.value && g(pe)(l.value),
        "aria-busy": ((k = g(e)) == null ? void 0 : k.handlers.buttonState) === g(x).Sending ? "true" : "false"
      }, [
        r.isLinkLayout ? (f(), b("span", {
          key: 1,
          innerHTML: l.value
        }, null, 8, ke)) : (f(), b("span", {
          key: 0,
          class: "thn--tool-button__label",
          innerHTML: l.value
        }, null, 8, Pe)),
        ((M = g(e)) == null ? void 0 : M.handlers.buttonState) === g(x).Sending && !r.isLinkLayout ? (f(), b("div", {
          key: 2,
          class: "thn--tool-button__sending loader",
          "aria-label": g(t)("Sending"),
          "aria-live": "polite"
        }, s[2] || (s[2] = [
          L("div", { class: "la-ball-pulse" }, [
            L("div", { "aria-hidden": "true" }),
            L("div", { "aria-hidden": "true" }),
            L("div", { "aria-hidden": "true" })
          ], -1)
        ]), 8, Me)) : te("", !0)
      ], 46, ve);
    };
  }
}), Le = ["data-button-alignment"], we = /* @__PURE__ */ K({
  __name: "CTAGroup",
  props: {
    moduleProps: {},
    hasExtraSteps: {},
    toolKind: {},
    layout: {}
  },
  setup(n) {
    const e = n;
    return (t, o) => {
      var l;
      return f(), b("div", {
        class: "thn--tool-cta-group",
        "data-button-alignment": e.moduleProps.alignment ?? "horizontal"
      }, [
        ne(V, {
          "has-extra-steps": e.hasExtraSteps,
          "tool-kind": e.toolKind,
          layout: e.layout,
          "is-link-layout": ((l = e.moduleProps.appearance) == null ? void 0 : l.layout) === "link",
          "module-props": e.moduleProps
        }, null, 8, ["has-extra-steps", "tool-kind", "layout", "is-link-layout", "module-props"]),
        (f(!0), b(oe, null, ae(t.moduleProps.secondaryButtons, (c) => {
          var i;
          return f(), j(V, {
            key: c.id,
            "has-extra-steps": e.hasExtraSteps,
            "tool-kind": e.toolKind,
            "is-link-layout": ((i = c.appearance) == null ? void 0 : i.layout) === "link",
            "is-secondary": !0,
            layout: e.layout,
            "module-props": c
          }, null, 8, ["has-extra-steps", "tool-kind", "is-link-layout", "layout", "module-props"]);
        }), 128))
      ], 8, Le);
    };
  }
}), _e = /* @__PURE__ */ K({
  __name: "Text",
  props: {
    moduleProps: {},
    toolKind: {},
    layout: {}
  },
  setup(n) {
    const e = {
      [a.Heading]: {
        fontSize: 24,
        lineHeight: 24
      },
      [a.Paragraph]: {
        fontSize: 16,
        lineHeight: 16
      },
      [a.Button]: {
        fontSize: 18,
        lineHeight: 18
      }
    }, t = q(), o = n, l = p(() => {
      var s;
      return t == null ? void 0 : t.literals.getActiveModuleText(
        o.moduleProps,
        ((s = t == null ? void 0 : t.styles.fonts[o.moduleProps.moduleType]) == null ? void 0 : s.textTransform) === $.Titlecase,
        {
          candidates: t.extraData.dynamicTags,
          replacement: t.extraData.tokens
        }
      );
    }), c = p(
      () => o.moduleProps.appearance || e[o.moduleProps.moduleType]
    ), i = p(
      () => {
        var s;
        return I(c.value, t == null ? void 0 : t.device, (s = o.layout) == null ? void 0 : s.size);
      }
    ), r = p(() => o.moduleProps.moduleType === "heading" ? "h2" : o.moduleProps.moduleType === "paragraph" ? "p" : "div");
    return (s, S) => (f(), j(re(r.value), {
      class: "thn--tool-text",
      style: U(i.value),
      innerHTML: l.value,
      "module-type": s.moduleProps.moduleType,
      "data-module-id": s.moduleProps.id,
      tabindex: "-1"
    }, null, 8, ["style", "innerHTML", "module-type", "data-module-id"]));
  }
});
export {
  _e as _,
  I as a,
  we as b,
  Te as c,
  V as d,
  D as g,
  fe as h,
  W as s,
  Ke as u
};
//# sourceMappingURL=Text.vue_vue_type_style_index_0_lang.-ztwnf54.js.map
